import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=6861d1ab&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6861d1ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6861d1ab')) {
      api.createRecord('6861d1ab', component.options)
    } else {
      api.reload('6861d1ab', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=6861d1ab&scoped=true&", function () {
      api.rerender('6861d1ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2T3DdXxwUY9I7/JS/comp/Voucher-Unit.vue"
export default component.exports